export default "/_next/static/chunks/fonts/pxiEyp8kv8JHgFVrJJbecmNE-7dbe1c3f3d8cc1ba2168366ea300c627.woff2";